import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=04186dae&scoped=true"
import script from "./OfferCard.vue?vue&type=script&lang=ts"
export * from "./OfferCard.vue?vue&type=script&lang=ts"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=04186dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04186dae",
  null
  
)

export default component.exports